/**
 * Maps error messages from panel-bff to translation keys
 * New format: { id, code, title, status, detail }
 */
export const getCampaignErrorMessage = (error, t) => {
  // Get error message from new format (title or detail) or legacy formats
  const errorMessage = error?.title || error?.detail || error?.message || error;

  // Handle string errors (from new format title/detail or legacy)
  if (typeof errorMessage === 'string') {
    if (errorMessage.includes('overlaps')) {
      return t('campaigns.messages.date-overlap');
    }
    if (errorMessage.includes('cancelled')) {
      return t('campaigns.messages.cancelled-update');
    }
    if (errorMessage.includes('After the campaign starts')) {
      return t('campaigns.messages.started-restriction');
    }
    if (errorMessage.includes('not found') || errorMessage.includes('Campaign not found')) {
      return t('campaigns.messages.not-found');
    }
    // Return the server message directly if no translation mapping exists
    return errorMessage;
  }

  // Handle nested response data (axios error structure)
  if (error?.response?.data) {
    return getCampaignErrorMessage(error.response.data, t);
  }

  return t('campaigns.messages.generic-error');
};

/**
 * Checks if an error is a date overlap error
 */
export const isDateOverlapError = (error) => {
  const errorMessage = error?.title || error?.detail || error?.message || error;
  if (typeof errorMessage === 'string' && errorMessage.includes('overlaps')) return true;
  return false;
};
